module.exports = __webpack_public_path__ + "media/images/landing/bg/case-emco/intro-6677d9fb99199652525f43911e0a506a.jpg";